import { StoreDispatch } from '@/store';
import { useDispatch } from 'react-redux';

export const useAppDispatch: () => StoreDispatch = useDispatch;
